import { Button } from "reactstrap";
import './Default.css';
import { ImSpinner8 } from "react-icons/im";

function DefaultButton({
  children, 
  color, 
  onClick, 
  loading,
  ...props
}) {
  return(
    <Button {...props} color={color || 'primary'} onClick={onClick} className={`${props.className || 'px-4'}`}>
      {loading ?
        <ImSpinner8 className="animation-spin" />
      :
        children
      }
    </Button>
  );
}

export default DefaultButton;